import type { FC, ReactNode } from 'react';

import { Stack } from '@packages/shared';

export type SlotsContainerProps = {
  children?: ReactNode;
};

export const SlotsContainer: FC<SlotsContainerProps> = ({ children }) => (
  <Stack data-testid="header-slots" direction="row" spacing={[1.5, 1.5, 1.5, 3]}>
    {children}
  </Stack>
);
